import { createFileRoute } from '@tanstack/react-router';
import JobListView from '../jobs/list/job-list-view';

export const Route = createFileRoute('/')({ component: JobListView });
